<template>
    <div class="dropzone-file">
        <div class="dropzone-file__icon">
            <img :src="`/images/dropzone/${icon}`" alt="" role="presentation" />
            <div class="dropzone-file__preview-image" :style="previewImageStyle" > </div>
            <span v-if="!isImage"  class="dropzone-file__icon-extension">
                {{extension}}
            </span>
        </div>
        <div class="dropzone-file__text">{{computedFile}}</div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            previewImageStyle: {}
        }
    },
    props: {
        file: {
            type: [String, File],
            required: true
        }
    },
    computed: {
        isFileString() {
            return this.file instanceof String || typeof this.file === 'string';
        },
        computedFile() {
            return this.isFileString ? this.file.split('/').pop() : this.file.name;
        },
        isImage() {
            return this.extension.match(/png|jpg|jpeg|gif/);
        },
        extension() {
          return this.computedFile.split('.').pop().toLowerCase();
        },
        icon() {
            if (this.isImage) {
                return 'file-image.svg';
            }
            if (this.extension.match('xls')) {
                return 'file-excel.svg';
            }
            return 'file-blank.svg';
        }
    },
    mounted() {
        // Read in preview image if it is a file
        if(this.isImage && !this.isFileString) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.previewImageStyle = {
                    'background-image' : `url(${e.target.result})`
                };
            }
            reader.readAsDataURL(this.file);
        }
    }

};
</script>
